<template>
    <rkm-table
        :fields="fields"
        :items="items"
        ref="RkmTable"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                @click="edit(row.item)"
                authorize="update-painel-senha-prioridade"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="destroy(row.item)"
                authorize="destroy-painel-senha-prioridade"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {
            return [
                {key: 'tipoNome', label: 'Tipo', sortable: true},
                {key: 'nome', label: 'Nome', sortable: true},
                {key: 'grau', label: 'Grau de prioridade', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    created() {
        this.repositories = {
            prioridade: this.getConectaSusRepository('painelSenha.prioridade')
        }
    },
    data: () => ({
        items: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.prioridade.index()
                .then(response => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit(item) {
            this.$router.push({ name: 'painel-senha-prioridade-edit', params: { id: item.id } })
        },
        destroy(item) {
            const destroy = () => this.repositories.prioridade.destroy(item.id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === item.id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir a prioridade?', destroy, this.handleError)
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>